<template>
    <div class="cloudClassroom_wrap">
        <div class="bg_img">
            <div class="banner_content">
                <div>
                    <div class="one">MaxSwell 云课堂</div>
                    <div class="two">数据科学领域一站式学习平台，以数据科学和人工智能为基础技术，提供从语法基础到专题知识应用等系列学习资源，不断汇聚刷新知识学习体系。</div>
                </div>
                <div><button id="startlearn" @click="moveTop">开始学习</button></div>
            </div>
        </div>

        <div class="classify">
            <span>云课堂资源分类</span>
        </div>
        <!-- 子组件 -->
        <el-tabs v-model="tabName" @tab-click="changeTab">
            <el-tab-pane  name="ProjectArticle">
                <span slot="label"><i class="iconfont icon-navicon-wzgl">&nbsp;专题文章</i></span>
                <ProjectArticle ></ProjectArticle>
            </el-tab-pane>
            <el-tab-pane  name="TeachingVideo ">
                <span slot="label"><i class="iconfont icon-shipin">&nbsp;教学视频</i></span>
                <TeachingVideo></TeachingVideo>
            </el-tab-pane>
            
        </el-tabs>
    </div>
</template>
<script>
import bus from '../../common/bus';
export default {
    data() {
        return {
            tabName:'ProjectArticle',
        };
    },
    mounted() {},
    methods: {
        changeTab(){},
        moveTop() {
            bus.$emit('changeScroll',800)
        }
    }
};
</script>
<style lang="scss" scoped>
.icon-navicon-wzgl,.icon-shipin{
    font-size: 25px;
}

/deep/.is-active{
    border-bottom: 5px solid #5277F7 !important;
}
/deep/.el-tabs__nav{
    width: 100% ;
    .el-tabs__item{
        width: 50%;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-size: 24px;
        // font-weight: bold;
    }
    .el-tabs__item:hover{
       background: #5277F7;
       color: white;
       border-radius: 3px 3px 0px 0px;
    }
}
.cloudClassroom_wrap {
    position: relative;
    background: #FCFCFF;
    .bg_img {
        width: 100%;
        height: 70vh;
        overflow: hidden;
        background: url(../../../assets/img/bg8.png) 0 0/100% 100% no-repeat;
        position: relative;
        .banner_content{
            position: absolute;
            top: 8vh;
            right: 10vw;
            .one {
                color: #5277f7;
                font-size: 50px;
                font-weight: 600;
                margin: 78px auto;
                margin-bottom: 0;
            }
            .two {
                width: 700px;
                line-height: 1.8;
                margin-top: 35px;
                // font-weight: 600;
                font-size: 22px;
                color: #5277f7;
            }
            #startlearn {
                box-shadow: -1px 4px 6px rgba(42, 73, 180, 0.4);
                display: block;
                margin-top: 10vh;
                height: 54px;
                width: 150px;
                background-image: linear-gradient(to right, #7dc3ea, #5277f7);
                border-radius: 30px;
                border: 0;
                line-height: 44px;
                font-size: 22px;
                color: #ffffff;
            }
        }
        
    }
    
    #startlearn:hover{
        opacity: 0.8;
        cursor: pointer;
    }
    .classify {
        width: 100%;
        text-align: center;
        padding: 20px 0;
        color: #5277f7;
        font-size: 35px;
        letter-spacing: 1px;
    }
    .select {
        width: calc(100% - 400px);
        height: 60px;
        margin-left: 200px;
        border-bottom: solid 2px #3c3c3c;
        .side {
            font-size: 22px;
            line-height: 60px;
            width: 100px;
            height: 40px;
            padding-bottom: 20px;
        }
        .side:hover {
            color: #5277f7;
            cursor: pointer;
            
        }
        // .side:active {
        //     color: #5277f7;
        // }
        .left_side {
            margin-left: 200px;
            float: left;
        }
        .right_side {
            // margin-left: 600px;
            position: relative;
            left: -200px;
            float: right;
        }
        .slide_line {
            width: 85px;
            height: 5px;
            background: #5278f7;
            margin-left: 200px;
        }
    }
    .page_wrap {
        height: 60px;
        line-height: 60px;
        margin-top: 30px;
        text-align: center;
    }
}

</style>
